import { useEffect, useState } from "react";

const useCountry = () => {
  const [countryData, setCountryData] = useState({
    country_name: "India",
    country_calling_code: "+91",
  });

  useEffect(() => {
    const stored = localStorage.getItem("countryData");

    if (stored) {
      setCountryData(JSON.parse(stored));
      return;
    }

    const fetchCountry = async () => {
      try {
        const res = await fetch("https://ipapi.co/json/");
        const data = await res.json();

        const formatted = {
          country_name: data?.country_name || "India",
          country_calling_code: data?.country_calling_code || "+91",
        };

        setCountryData(formatted);
        localStorage.setItem("countryData", JSON.stringify(formatted));
      } catch (error) {
        console.log("Country API failed", error);
      }
    };

    fetchCountry();
  }, []);

  return countryData;
};

export default useCountry;